import { createAction, props } from '@ngrx/store';
import { User } from '../../../auth/model/user';
import { ForgotPasswordResponse } from '../../../auth/model/forgot-password-response';
import { ResetPassword } from '../../../auth/model/reset-password';
import { ResetPasswordResponse } from '../../../auth/model/reset-password-response';

export const loginSuccess = createAction(
  '[Auth/API] Login Success',
  props<{user: User, url: string}>()
);

export const loginFailure = createAction(
  '[Auth/API] Login Failure',
  props<{error: any}>()
);

export const loginRedirect = createAction(
  '[Auth/API] Login Redirect',
  props<{url: string}>()
);

export const logoutSuccess = createAction('[Auth/API] Logout Success');

export const logoutFailure = createAction(
  '[Auth/API] Logout Failure',
  props<{error: any}>()
);

export const forgotPasswordSuccess = createAction(
  '[Auth/API] Forgot Password Success',
  props<{data: ForgotPasswordResponse}>()
);

export const forgotPasswordFailure = createAction(
  '[Auth/API] Forgot Password Failure',
  props<{error: any}>()
);

export const resetPasswordSuccess = createAction(
  '[Auth/API] Reset Password Success',
  props<{data: ResetPasswordResponse}>()
);

export const resetPasswordFailure = createAction(
  '[Auth/API] Reset Password Failure',
  props<{error: any}>()
);

export type AuthApiActionsUnion = ReturnType<
  typeof loginSuccess |
  typeof loginFailure |
  typeof loginRedirect |
  typeof logoutSuccess |
  typeof logoutFailure |
  typeof forgotPasswordSuccess |
  typeof forgotPasswordFailure|
  typeof resetPasswordSuccess |
  typeof resetPasswordFailure
  >;

